export const socialsData = {
    github: 'https://github.com/AbdullahShion',
    facebook: 'https://www.facebook.com/abdullahalmamun.shion/',
    linkedIn: 'https://www.linkedin.com/in/mohammad-abdullah-8a12611b2/',
    instagram: 'https://www.instagram.com/abdullahshion/',
    codepen: 'https://codepen.io/abdullahshion',
    twitter: 'https://twitter.com/',
    reddit: 'https://www.reddit.com/user/',
    blogger: 'https://www.blogger.com/',
    medium: 'https://medium.com/@',
    stackOverflow: 'https://stackoverflow.com/users/',
    gitlab: 'https://gitlab.com/mohammad15-2051',
    youtube: 'https://www.youtube.com/channel/UCHg2GJhgds2Y3MaY319lBUw/featured'
}